import React, { createContext, useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

const SidebarContext = createContext();

const SidebarProvider = ({ initialCollapsed = false, children = null }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(initialCollapsed);

  const value = useMemo(
    () => ({ sidebarCollapsed, setSidebarCollapsed }),
    [sidebarCollapsed, setSidebarCollapsed]
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
};

SidebarProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf([PropTypes.node])]),
  initialCollapsed: PropTypes.bool
};

const useSidebar = () => useContext(SidebarContext);

export { SidebarContext, SidebarProvider, useSidebar };
